import { render } from "./TicketDetailChat.vue?vue&type=template&id=5d5664d0"
import script from "./TicketDetailChat.vue?vue&type=script&lang=js"
export * from "./TicketDetailChat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__